var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 120C501.254 120 512 109.254 512 96S501.254 72 488 72H24C10.746 72 0 82.746 0 96S10.746 120 24 120H488ZM24 224C10.746 224 0 234.746 0 248V424C0 437.254 10.746 448 24 448S48 437.254 48 424V248C48 234.746 37.254 224 24 224ZM488 232H152C138.746 232 128 242.746 128 256S138.746 280 152 280H488C501.254 280 512 269.254 512 256S501.254 232 488 232ZM488 392H152C138.746 392 128 402.746 128 416S138.746 440 152 440H488C501.254 440 512 429.254 512 416S501.254 392 488 392Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockQuote);
export default __webpack_public_path__ + "static/media/block-quote.5c4637e5769c20a9bd2ac0ce4aa34cd4.svg";
export { ForwardRef as ReactComponent };